export default [
  {
    name: 'Membership Plan',
    prop: 'membership_plan_id',
    type: 'autocomplete',
    references: 'admin/membership_plans',
    referenceProp: 'name'
  },
  {
    name: 'Expires',
    prop: 'expires_at',
    type: 'date'
  },
  { name: 'Create order', prop: 'create_order', type: 'checkbox' }
]
